// @ts-nocheck
import FacebookIcon from '@/img/icons/facebook.svg?component';
import TwitterIcon from '@/img/icons/x.svg?component';
import InstagramIcon from '@/img/icons/instagram.svg?component';
import YoutubeIcon from '@/img/icons/youtube.svg?component';

export default (name: string) => {
  return new URL(`@/img/${name}.svg`, import.meta.url).href;
};

const SOCIAL_NETWORK_ICONS = {
  facebook: FacebookIcon,
  x: TwitterIcon,
  instagram: InstagramIcon,
  youtube: YoutubeIcon,
};

export const resolveSocialNetworkIconComponent = (name: string) => {
  return SOCIAL_NETWORK_ICONS[name] || undefined;
};
